import React, { useContext } from "react";
import { MdReport, MdClear } from "react-icons/md";
import AuthContext from "../context/AuthContext";

function Error({ message, title = "Error", close }) {
  const { setLoginError } = useContext(AuthContext);
  return (
    <div className="absolute w-screen top-5 flex justify-center z-50">
      <div className="bg-red-100 flex items-center justify-between p-3 w-96 rounded-xl border-2 border-red-400">
        <div className="flex items-center gap-2 ">
          <div className="bg-red-600 p-1.5 rounded-full mr-1">
            <MdReport className="text-2xl text-white" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-700">{title}</p>
            <p className="text-xs text-gray-700">{message}</p>
          </div>
        </div>
        <MdClear
          onClick={() => {
            close ? close() : setLoginError(false);
          }}
          className="text-2xl text-red-600 hover:text-red-900"
        />
      </div>
    </div>
  );
}

export default Error;
